<template>
  <el-dialog
    title="选择服务"
    :visible.sync="visible"
    width="600px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.serviceCategoryName"
        placeholder="请输入服务名称"
        style="width: 200px"
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      :data="list"
      @row-click="handleRowClick">
      <el-table-column
        label="服务名称"
        min-width="200"
        prop="serviceCategoryName"></el-table-column>
      <el-table-column
        label="添加状态"
        min-width="90"
        prop="vendorAddress">
        <template slot-scope="{ row }">
          {{ row.selected ? '已添加' : '' }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange">
    </el-pagination>
    <div slot="footer">
      <el-button @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'WeSeriesSelectModal',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      visible: false,
      config: { pageNum: 1, pageSize: 10, serviceId: null, serviceCategoryName: '' },
      selection: []
    }
  },
  methods: {
    handleClosed() {
      this.list = []
      this.config.serviceId = null
      this.config.serviceCategoryName = ''
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    handleRowClick(row) {
      const { serviceCategoryId, serviceCategoryName, selected } = row
      if (selected) {
        this.$message.error('当前服务已添加')
        return
      }
      this.$emit('select', { serviceCategoryId, serviceCategoryName })
      this.selection.push(serviceCategoryId)
      this.countSelection(this.list)
      // this.visible = false
    },
    countSelection(list) {
      const selection = this.selection
      this.list = list.map(i => ({ ...i, selected: selection.includes(i.serviceCategoryId) }))
    },
    fetchList() {
      this.loading = true
      this.$$examApi.getservicecategorys2(this.config)
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.total = total
            this.countSelection(records)
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(selection = []) {
      this.selection = selection
      this.visible = true
      this.fetchList()
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
